import { useContext } from "react";
import { notificationContext } from "../context/NotificationContext";

function useAddNotification() {
    const { addNotification } = useContext(notificationContext);
    return addNotification;
}

export default useAddNotification;
